import { render, staticRenderFns } from "./release_group_edit.vue?vue&type=template&id=7026e613&scoped=true"
import script from "./release_group_edit.vue?vue&type=script&lang=js"
export * from "./release_group_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7026e613",
  null
  
)

export default component.exports